<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="5">
        <el-input v-model="form.payAccount" size="small" placeholder="收款方" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5">
        <el-input v-model="form.payAccountNum" size="small" placeholder="收款账号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5">
        <el-select v-model="form.auditStatus" size="small" placeholder="审批状态" class="w-100">
          <el-option v-for="(label, value) in approveConfig.getConfigList('statusSettlement')" :key="value" :label="label" :value="value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <div class="table-wrap">
      <p class="table-count">其他付款总数：{{ page.total }}条</p>
      <el-table v-loading="tableLoading" :data="tableData" size="small">
        <el-table-column label="付款编号" prop="code" align="center">
        </el-table-column>
        <el-table-column label="关联投放记录" prop="putInCodes" align="center">
        </el-table-column>
        <el-table-column label="收款方" prop="payAccount" align="center">
        </el-table-column>
        <el-table-column label="收款账号" prop="payAccountNum" align="center">
        </el-table-column>
        <el-table-column label="开户行" prop="depositBank" align="center">
        </el-table-column>
        <el-table-column label="付款主体" prop="yhgBankAccount" align="center">
        </el-table-column>
        <el-table-column label="原始金额" prop="payAmountOriginal" align="center">
        </el-table-column>
        <el-table-column label="实付金额" prop="payAmount" align="center">
        </el-table-column>
        <el-table-column label="批次调整项" prop="transPriceNew" align="center">
        </el-table-column>
        <el-table-column label="批次调整备注" prop="transRemarkBatch" align="center">
        </el-table-column>
        <el-table-column label="备注" prop="batchRemark"  align="center" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="附件" prop="fileList" align="center">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.fileList"></filePreview>
          </template>
        </el-table-column>
        <el-table-column label="审批时间" prop="auditTime" align="center" width="150" v-if="type === 'Processing'"></el-table-column>
        <el-table-column label="审批状态" prop="status" align="center">
          <template slot-scope="scope">
            <p>
              {{ approveConfig.getAppointed("statusPay", scope.row.auditStatus, "") }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="审批人" prop="approverName" align="center"  ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.auditStatus==12||scope.row.auditStatus==14||scope.row.auditStatus==16
            ||scope.row.auditStatus==18||scope.row.auditStatus==20||scope.row.auditStatus==22
            ||scope.row.auditStatus==24||scope.row.auditStatus==26||scope.row.auditStatus==28" type="text" size="small" @click="addBatchShopcar(scope.row)">一键加入购物车</el-button>
            <el-button  type="text" size="small" @click="openTrans(scope.row)">信息备注</el-button>
            <el-button  type="text" size="small" @click="toDetail(scope.row.id)">明细</el-button>
            <el-upload  :id="'upload-file-3'" :key="'file-3'" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :on-success="uploadSuccess"
              :on-error="uploadError" multiple :before-upload="beforeUpload" @on-change="beforeChange" :show-file-list="false" :accept="'*.*'">
              <el-button v-if="scope.row.uploadFlag==0" type="text" size="small" @click="pidClick(scope.row.id)">上传附件</el-button>
            </el-upload>
          </template>
          
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <el-dialog :title="dialogTitleNew" width="30%" :visible.sync="dialogTableVisibleNew">
      <el-form v-if="dialogTitleNew==='信息备注'" label-position="left" :model="transForm" ref="transForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="transForm.batchRemark" rows="4" show-word-limit placeholder="请输入备注" maxlength="100"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="saveClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisibleNew = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/util/validate";
import util from "@/util/util";
import { customConfig } from "@/const/config/custom";
import { approveConfig } from "@/const/config/approve";

import { bloggerSettlementAllList ,saveFile ,updateBatchRemark } from "@/api/approve/settlement";
import { addBatchShopcar } from "@/api/pay/api";
import * as qiniu from "qiniu-js";
import { qiniuToken } from "@/api/index";
export default {
  props: ["type"],

  data() {
    return {
      object: null,
      customConfig: customConfig,
      approveConfig: approveConfig,

      form: {
        payAccount: "",
        payAccountNum: "",
      },

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      dialogTableVisibleNew:false,
      dialogTitleNew:"",
      transForm: {
        id:"",
        batchRemark:"",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        nameOrCode: "",
        createUserName: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
       queryObj.auditFlag = 1 ;
      queryObj.payType = 4;
      console.log("queryObj", queryObj);
      this.tableLoading = true;
      bloggerSettlementAllList(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.object = res.object;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },

    addBatchShopcar(obj){
      var queryObj = {} ;
      queryObj.payType = 1 ;
      queryObj.code = obj.code ;
      console.log(queryObj);
      addBatchShopcar(obj).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '加入购物车成功!',
            type: 'success'
          });
          
        }
      })
    },


    /**
     * 展示原因
     * @param text 原因类型
     * @param reason 原因
     */
    onShowReason(text, reason) {
      reason = reason || "原因";
      text = text || "";
      this.$alert(text, reason, {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 跳转到审批页
     */
    toAssess(id) {
      let router = this.$router.push({
        path: "/pay/blogger/batchform",
        query: {
          id,
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },


    beforeChange(file, fileList){
      console.log('========123=======',file, fileList)
    },

    pidClick(id){
      this.pid = id;
      this.imgList=[]
      this.imageIndex=[]
    },
    /**
     * 上传图片
     */
    async beforeUpload(file) {
      this.imageIndex.push(file)
      console.log('======值=====',this.imageIndex.length)
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error("文件大小不能超过500M");
        return false;
      }
      qiniuToken()
        .then((res) => {
          let fileName = Date.now() + file.name;
          var observable = qiniu.upload(file, fileName, res.data);
          console.log(observable);
          observable.subscribe({
            next(res) {},
            error(error) {
              this.$message.error("上传失败");
            },
            complete: (complete) => {
              console.log("complete");
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              this.imgList.push({
                "name": file.name,
                "path": qiniuBaseUrl + complete.key
              })
              if(this.imageIndex.length === this.imgList.length){
                let obj = {
                  id: this.pid,
                  fileList:this.imgList
                };
                saveFile(obj).then((res) => {
                  if (res.code == 1) {
                    this.$message.success("上传成功！");
                    this.getList();
                  }
                });
              }
            },
          });
        })
        .catch((error) => {});
      return false;
    },
    //上传文件成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    //上传文件失败
    uploadError(res, file) {
      console.log("error", res, file);
    },

    //打开修改信息输入框
    openTrans(obj){
      this.dialogTitleNew = '信息备注' ;
      this.dialogTableVisibleNew = true ;
      console.log("======"+obj);
      this.transForm.id = obj.id;
      this.transForm.batchRemark = obj.batchRemark;
    },

    //保存修改信息
    saveClick(){
      if(this.transForm.batchRemark == ''){
			  this.$message.error('请先填写备注');
			  return
		  }
      updateBatchRemark(this.transForm).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '修改备注信息成功!',
            type: 'success'
          });
          this.dialogTableVisibleNew = false
          this.getList();
        }
        console.log('=======修改备注信息成功=====',res)
      })
    },


    toDetail(id) {
      let router = this.$router.resolve({
        path: "/check/pay/other",
        query: {
          id,
          flag:""
        },
      });
      window.open(router.href, "_blank");
    },


    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
};
</script>

<style lang="scss" scoped>
.table-count {
  margin: 15px 0 10px;
}
</style>